import m from "../../geodata/es2015/continentsRussiaAsiaHigh";
window.am4geodata_continentsRussiaAsiaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/continentsRussiaAsiaHigh.js
// module id = null
// module chunks = 